export const searchKeys = {
  workspaceContainers: (workspaceSlug: string, query: string, projectId?: string) =>
    ["search", "workspace", workspaceSlug, query, projectId ?? "all"] as const,
  workspaceMessages: (workspaceSlug: string, query: string, projectId?: string) =>
    ["search", "workspace", "messages", workspaceSlug, query, projectId ?? "all"] as const,
  documentContent: (workspaceSlug: string, query: string, projectId?: string) =>
    ["search", "workspace", "doc-content", workspaceSlug, query, projectId ?? "all"] as const,
};
